import { connect } from 'react-redux';
import Viewer from '../../components/Viewer/Viewer';
import { announce } from '../../actions/announcements';

const mapStateToProps = () => ({
  url: '/c/application/journal/introduction.html',
  pageName: 'Introduction',
});

const mapDispatchToProps = (dispatch) => ({
  onLoad: (pageName) => {
    dispatch(announce(`${pageName} page loaded`));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Viewer);
